import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const appointmentApi = createApi({
  reducerPath: 'appointmentApi',
  baseQuery: rtkBaseQuery('/resource/Appointment'),
  providesTags: ['Appointment'],
  endpoints: (builder) => ({
    getAllAppointmentPurpose: builder.query({
      query: () => '/GetAllAppointmentPurpose',
    }),
    createPurpose: builder.mutation({
      query: (body) => ({
        url: '/CreatePurpose',
        method: 'POST',
        body,
      }),
    }),
    editStatus: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/EditPurpose/${id}`,
        method: 'PUT',
        body: rest,
      }),
    }),
    deleteAppointment: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/DeletePurpose?Id=${id}`,
        method: 'DELETE',
        body: rest,
      }),
    }),
  }),
});

export const {
  useGetAllAppointmentPurposeQuery,
  useCreatePurposeMutation,
  useEditStatusMutation,
  useDeleteAppointmentMutation,
} = appointmentApi;
